import { useQuery } from '@tanstack/react-query';
import { getAppointmentsData, getAssistanceData } from '../../services/getAssistances.service';

export const useStartPageQueries = ({
  user,
  scope,
  scopeType,
  startPageFilters,
  projectIds,
  currentUserRole,
  projects,
}) => {
  const isReady = !!scope;

  const appointmentsQuery = useQuery(
    ['appointmentsData', scope?.id],
    () =>
      getAppointmentsData(
        user,
        scope,
        scopeType,
        startPageFilters,
        projectIds,
        projects,
        currentUserRole
      ),
    {
      enabled: isReady,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: Infinity,
      cacheTime: 1000 * 60 * 10,
      onError: () => {
        console.error('Erro ao buscar próximos atendimentos');
      },
    }
  );

  const assistanceQuery = useQuery(
    ['openedOrFinished', scope?.id],
    () =>
      getAssistanceData(
        user,
        scope,
        scopeType,
        startPageFilters,
        projectIds,
        projects,
        currentUserRole
      ),
    {
      enabled: isReady,
      refetchOnWindowFocus: false,
      retry: false,
      staleTime: Infinity,
      cacheTime: 1000 * 60 * 10,
      onError: () => {
        console.error('Erro ao buscar atendimentos abertos e fechados');
      },
    }
  );

  return {
    appointmentsQuery: appointmentsQuery.data,
    assistanceQuery: assistanceQuery.data,
    loadingAppointments: appointmentsQuery.isLoading,
    loadingAssistance: assistanceQuery.isLoading,
    refetchingAppointments: appointmentsQuery.isRefetching,
    refetchingAssistance: assistanceQuery.isRefetching,
    isInitialLoading:
      appointmentsQuery.isInitialLoading || assistanceQuery.isInitialLoading,
    refetchAll: () => {
      appointmentsQuery.refetch();
      assistanceQuery.refetch();
    },
  };
};
